// extracted by mini-css-extract-plugin
export default {"icon":"IconWithPlaceholder_icon__MZUoG","roundedSquare":"IconWithPlaceholder_roundedSquare__nz+E7","circle":"IconWithPlaceholder_circle__tZZV4"};